import React, { useState } from 'react';

import { showToast } from '@opendoor/bricks/complex/Toast';
import { Button, Flex, Text } from '@opendoor/bricks/core';

import { OdProtosListingsData_Listing_State as ListingState } from '../../__generated__/athenaGlobalTypes';
import { useSetListingDetails } from '../../graphql/athena/mutations/SetListingDetails';
import { isValidDateForLwc } from '../../routes/LwcDashboard/utils';

type SoldFormProps = {
  listingId: string;
};

/** Set the listing details listing price, sold price, commission */
export const SoldForm: React.FC<SoldFormProps> = ({ listingId }) => {
  /** These names need to be in snake_case because of the way the updateMasks is set for this service */
  const [date, setDate] = useState('');
  const isValidDate = isValidDateForLwc(date);
  const isoDate = isValidDate ? new Date(date).toISOString() : '';
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputDate = e.target.value;
    setDate(inputDate);
  };
  const { setListingDetails, error, loading } = useSetListingDetails();

  const handleSoldDate = async (soldDate: string) => {
    setListingDetails({
      params: {
        id: listingId,
        nextState: ListingState.SOLD,
        updateMask: {
          paths: ['next_state', 'timestamp_overrides'],
        },
        timestampOverrides: [{ state: ListingState.SOLD, timestamp: soldDate }],
      },
    })
      .then(() => {
        showToast('info', `Successfully closed the listing`, 'lwc-dashboard-toast}', {
          toastOptions: { autoClose: 3000 },
        });
      })
      .catch((_) => {});
  };

  if (error) {
    showToast('error', `Error setting selling details`, 'lwc-dashboard-toast', {
      toastOptions: { autoClose: false },
    });
  }
  return (
    <Flex flexDirection="column">
      <Text>What day did the home actually sell?</Text>
      <input type="date" value={date} onChange={handleDateChange} />
      <Button
        my={3}
        aria-label="Submit when the home was actually sold"
        analyticsName="set-home-sold"
        onClick={() => handleSoldDate(isoDate)}
        disabled={!isValidDate || loading}
        loading={loading}
      >
        Close out listing
      </Button>
    </Flex>
  );
};
